import * as API from "../framework/api.js";

// To use any of these functions in a component, just set x-data="utils"
// now in all of the children elements you can access the functions directly (no need for utils.functionName, just call functionName)

export default () => ({
  async submitOnChange(e, method = "POST") {
    const action = e.target.dataset.action;
    let data = {};
    data[e.target.name] = e.target.checked;

    await API.fetchJSON(action, {
      method: method,
      body: data,
    }).then((res) => {
      if (!res.success) {
        location.reload();
      }
    });
  },

  // This function is here to open accordions if there are errors in the form submission
  maybeOpenAccordionsOnSubmit() {
    const form = document.querySelector("form");
    if (form) {
      const validity = form.checkValidity();
      if (!validity) {
        const invalidFields = form.querySelectorAll(":invalid");
        invalidFields.forEach((field) => {
          const parent = field.closest("details");
          parent.open = true;
        });
      }
    }
  },
});
